<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{observationInfo.Title}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body">
      <div>
          <div>
            <div class="input-container" *ngIf="observationInfo.Title!='Cannon Extension' && observationInfo.Title!='Scallop'">
              <span class="input-desc-label">{{'Minimum Allowed' | translate | async}} ({{uom}})</span>
              <input  [(ngModel)]="observationInfo.Min" type="number">
            </div>
            <div class="input-container">
              <span class="input-desc-label">{{'Maximum Allowed' | translate | async}} ({{uom}})</span> 
              <input  [(ngModel)]="observationInfo.Max" type="number">
            </div>
          </div>
          <div class="margin-bottom-24">
            <div class="input-desc-label">{{'You can attach a photo of this measurement point ' | translate | async}}</div>
            <input type="file" accept="image/*"  (change)="onSelectObsPhoto($event)">
            <div style="margin-top: 8px;">
              <img style="width:100px; height:100px" *ngIf="observationInfo.ToolImage" [src]="sanitize(observationInfo.ToolImage)">
            </div>
          </div>
      </div>
      <div class="ttmodal__footer">
        <button mat-raised-button (click)="onNoClick()">{{'Cancel' | translate | async}}</button>
        <button mat-raised-button color="warn"  (click)="Update()">
            <span class="material-icons button__icon">check</span>
            <span class="button__text">{{'Update' | translate | async}}</span>
        </button>
      </div>
  </div>